// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HzBxV","card":"Modal_card__Br0Vv"};